<template>
	<transition name="modal">
		<div class="fixed inset-0 flex justify-center items-center bg-trans-gray z-20" v-show="show">
			<div class="max-w-full rounded shadow sm:w-1/2 bg-white sm:mt-2" >
				<div v-if="catId!=9" class="flex items-center justify-between rounded-t bg-gray-800 p-4 text-white font-thin text-lg">
					<div>Add {{ $store.getters.getProductCategoryNameById(catId) }}</div>
					<add-product-button class="link" :cat-id="catId" @reload="loadCategoryProducts">New Product</add-product-button>
				</div>
				<div class="p-4 overflow-y-scroll" style="max-height: 80vh">
					<div v-if="loading" class="text-grey-darker">
						Loading...
					</div>
					<div v-else-if="!mergedProducts.length" class="text-grey-darker">
						No Products
					</div>
					<div v-else>
						<div class="flex flex-wrap items-center " :class="{'justify-between':(setName || catId == 1)}">
							<div class="flex-1 flex flex-wrap items-center sm:mr-6" v-if="setName">
								<label class="w-full sm:w-auto inline-block mr-4 text-gray-700 text-sm" for="name">Name</label>
								<input class="appearance-none flex-1 border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" name="name" type="text" v-model="theName" placeholder="">
							</div>
							<div class="flex-1 flex flex-wrap items-center sm:mr-6" v-if="catId == 1">
								<select v-model="floor" name="floor" class="form-select mt-1 block ml-1 w-full">
									<option value="0">Ground Floor</option>
									<option value="1">First Floor</option>
									<option value="2">Second Floor</option>
									<option value="3">Third Floor</option>
									<option value="4">Fourth Floor</option>
									<option value="5">Fifth Floor</option>
								</select>
							</div>
							<div class="flex-1 flex flex-wrap items-center mt-2 sm:mt-0">
								<label class="w-full sm:w-auto inline-block mr-4 text-gray-700 text-sm" for="search">Search</label>
								<input class="appearance-none flex-1 border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" name="search" type="text" v-model="searchTerm" placeholder="">
							</div>
						</div>
						<div v-if="(areaId>0 && !specialArea)|| this.$route.name === 'Forecast Order' || this.$route.name === 'Create Order'" class="appearance-none flex-1 rounded mt-2 focus:outline-none focus:shadow-outline" :class="{'justify-between':setName}">
							<label class="w-full sm:w-auto inline-block mr-4 text-gray-700 text-sm" for="comment">Comment</label>
							<textarea name="comment" class="appearance-none bg-white rounded border border-gray-200 w-full p-1" v-model="comment" placeholder="" id="comment"></textarea>
						</div>
						<div class="pt-4">
							<div class="flex items-center my-2" v-for="(product, index) in searchProducts" :key="index">
								<input class="w-12 sm:w-24 appearance-none border rounded mr-4 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.allocated" @input="putFeedsDefaultValue(catId, product.id)" placeholder="qty">
								<label class="flex-1 order-first sm:order-none inline-block mr-4 text-gray-700 text-sm" :class="{'text-blue-700 font-bold': product.allocated}">
									{{ product.name+' /'+product.unit_measure }}
									<!-- <span class="block text-xs text-gray-500 font-normal">
										{{ product.pack_size > 1 ? product.description : product.pack_size+' '+product.unit_measure}}
									</span> -->
								</label>
								<template v-if="product.feeds >= 0">
									<input class="w-12 sm:w-24 appearance-none border rounded mr-4 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.feeds" placeholder="feeds" v-if="$store.getters.getProductCategoryNameById(catId) === 'Reticulation'">
								</template>
								<template v-else>
									<input class="w-12 sm:w-24 appearance-none border rounded mr-4 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="inputFeeds[product.id]" placeholder="feeds" v-if="$store.getters.getProductCategoryNameById(catId) === 'Reticulation'">
								</template>
								<template v-if="product.price_estimated >= 0">
									<input class="w-12 sm:w-24 appearance-none border rounded mr-4 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.price_estimated" placeholder="price" v-if="$store.getters.getProductCategoryNameById(catId) === 'Reticulation'">
								</template>
								<template v-else>
									<input class="w-12 sm:w-24 appearance-none border rounded mr-4 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="inputPriceEstimated[product.id]" placeholder="price" v-if="$store.getters.getProductCategoryNameById(catId) === 'Reticulation'">
								</template>
							</div>
						</div>
					</div>
				</div>
				<div class="rounded-b bg-gray-200 px-4 py-2">
					<div class="flex items-center justify-between">
						<action-button class="link mr-6" @button-clicked="cancel">Cancel</action-button>
						<action-button class="btn btn-blue" @button-clicked="save">Save</action-button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import AddProductButton from '@/components/common/AddProductButton.vue'
export default {
	props: ['show', 'block', 'catId', 'areaId', 'exisitingProducts', 'setName', 'specialArea', 'theFloor', 'theUnit', 'fetchOnLoad'],
	data () {
		// console.log(this.setName)
		return {
			loading: true,
			theName: typeof this.setName === 'boolean' ? '' : this.setName,
			floor: this.theFloor,
			unit: this.theUnit,
			products: this.exisitingProducts,
			fetchedProducts: {},
			searchTerm: '',
			comment:'',
      		inputFeeds: [],
      		inputPriceEstimated: [],
		}
	},
	methods: {
		cancel () {
			this.$emit('close')
		},
		save () {
      		var obj = { 'products': this.onlyIdAndAllocatedProps }
      		let newArr = []
      		if(this.inputFeeds.length > 0) {
				for(let i=0;i<obj.products.length; i++){
					newArr.push({
						'product_id': obj.products[i].product_id,
						'category_id': obj.products[i].category_id,
						'allocated': obj.products[i].allocated,
						'feeds': obj.products[i].feeds === undefined ? this.inputFeeds[obj.products[i].product_id] : obj.products[i].feeds,
						'price_estimated': obj.products[i].price_estimated === undefined ? this.inputPriceEstimated[obj.products[i].product_id] : obj.products[i].price_estimated
					})
				}
				var updateObj = { 'products': newArr }
			}else{
				var updateObj = { 'products': this.onlyIdAndAllocatedProps }
			}
			if (this.setName) {
				if (this.theName === '') {
					this.$store.commit('setStatus', { message: 'Name is required', type: 'error' })
					return
				}
				updateObj.area = this.theName
				if (this.areaId) {
					updateObj.areaId = this.areaId
					updateObj.comment = this.comment
				}
			}
			this.$emit('save', updateObj, this.catId)
		},
		loadCategoryProducts: function () {
			// console.log(this.postParams)
			this.$http.post('productsbycategory', this.postParams)
				.then(response => {
					this.fetchedProducts = response.data.products
				})
				.catch(error => {
					// console.log(error)
					let err = {
						title: 'Server responded with a ' + error.response.status,
						message: error.response.data.message,
						type: 'error'
					}
					this.$store.commit('setStatus', err)
				})
				.finally(() => {
					this.loading = false
				})
		},
		putFeedsDefaultValue: function (catId, productId) {
			if(this.$store.getters.getProductCategoryNameById(catId) === 'Reticulation') {
				this.inputFeeds[productId] = "1"
				this.inputPriceEstimated[productId] = "0"
			}
		}
	},
	components: {
		AddProductButton
	},
	computed: {
		postParams: function () {
			return {
				category_id: this.catId,
				floor: this.floor,
			}
		},
		searchProducts: function () {
			if (this.searchTerm.trim() === '') return this.mergedProducts
			return this.mergedProducts.filter(product => {
				return product.name.toLowerCase().includes(this.searchTerm.toLowerCase())
			})
		},
		mergedProducts: function () {
			let products = this.filteredProductsByFloor;
			if (products.length) {
				return this.$_.unionBy(products, this.fetchedProducts, "id");
			}
			return this.fetchedProducts
		},
		onlyIdAndAllocatedProps: function () {
			console.log(this.mergedProducts.filter(product => product.id == 245));
			return this.$_.reduce(this.mergedProducts, (newObj, product, k) => {
				if (product.allocated) {
					newObj.push({
						'product_id': product.id,
						'category_id': product.category_id,
						'allocated': product.allocated,
						'feeds': product.feeds,
						'floor': this.floor,
						'price_estimated': product.price_estimated
					})
				}
				return newObj
			}, [])
		},
		filteredProductsByFloor() {
			if(this.floor || this.floor === 0){
				return this.products.filter(product => {
					return product.floor == this.floor;
				})					
			}
			return this.products
		}
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})
		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		})
		if(this.fetchOnLoad){
			let url = false;
			let jobId = this.$route.params.id;
			switch(this.catId){
				case 5:
					url = `jobs/${jobId}/phases/${this.block.block_detail.phase_id}/blocks/${this.block.block_detail.id}/units/${this.unit}`;
				break;
			}
			if(url){
				this.$http.get(url)
					.then(response => {
						this.products = response.data.productslist;
					})
					.catch(err => {
						this.error = err
					})
					.finally(() => {
					});				
			}
		}
		this.loadCategoryProducts()
	}
}
</script>
